import { FunctionComponent, useContext, useEffect } from "react";

//OpenLayers
import { DoubleClickZoom } from "ol/interaction";

//Custom components
import MapContext from "@/components/Map/MapContext";
import { registerOlInteraction } from "@/lib/olHelpers";

//Types
import { MapContextType } from "@/@types/context/MapContext";
import { IDoubleClickZoomInteraction } from "@/@types/components/Map/Interactions/OpenLayers";

const DoubleClickZoomInteraction: FunctionComponent<IDoubleClickZoomInteraction> = (props) => {
  const context = useContext(MapContext) as MapContextType;

  const options = {
    duration: undefined,
    delta: undefined
  };

  const events = {
    change: undefined,
    "change:active": undefined,
    error: undefined,
    propertychange: undefined
  };

  useEffect(
    () =>
      registerOlInteraction(context, DoubleClickZoom, props, options, events),
    []
  );

  return null;
};

export default DoubleClickZoomInteraction;

